// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2I-vX","top":"styles_top__1QMcN","left":"styles_left__3_Pkd","description":"styles_description__1VStI"};